export default {
    SUPPLIER(state, items) {
        state.items = items
    }
}